/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Settings_Files_TitleInputs */

const es_settings_files_title = /** @type {(inputs: Settings_Files_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gestión de archivos`)
};

const en_settings_files_title = /** @type {(inputs: Settings_Files_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`File Management`)
};

/**
* | output |
* | --- |
* | "File Management" |
*
* @param {Settings_Files_TitleInputs} inputs
* @param {{ locale?: "es" | "en" }} options
* @returns {LocalizedString}
*/
const settings_files_title = /** @type {((inputs?: Settings_Files_TitleInputs, options?: { locale?: "es" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Files_TitleInputs, { locale?: "es" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_settings_files_title(inputs)
	return en_settings_files_title(inputs)
});
export { settings_files_title as "settings.files.title" }